import { FunctionComponent, ReactNode } from 'react'
import { Card, CardContent } from '@black-bear-energy/rucksack'

interface SiteRFPDetailCardProps {
  children: ReactNode
  variant?: 'elevation' | 'outlined'
}

export const SiteRFPDetailCard: FunctionComponent<SiteRFPDetailCardProps> = ({
  children,
  variant = 'elevation',
}) => {
  return (
    <Card variant={variant} sx={{ display: 'flex', flex: 1 }}>
      <CardContent
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          '&:last-child': {
            paddingBottom: 2,
          },
        }}
      >
        {children}
      </CardContent>
    </Card>
  )
}
